import { createContext, useContext, useState, useEffect } from 'react';

const AnimationContext = createContext();

export const useAnimation = () => {
  const context = useContext(AnimationContext);
  if (!context) {
    throw new Error('useAnimation must be used within an AnimationProvider');
  }
  return context;
};

export const AnimationProvider = ({ children }) => {
  const [useTransformersAnimation, setUseTransformersAnimation] = useState(() => {
    // Load from localStorage or default to false (simple CSS animation)
    const saved = localStorage.getItem('animationMode');
    return saved ? saved === 'transformers' : false;
  });

  const [useAnimatePresence, setUseAnimatePresence] = useState(() => {
    // Load from localStorage or default to true
    const saved = localStorage.getItem('useAnimatePresence');
    return saved ? saved === 'true' : true;
  });

  const [useRouteAnimatePresence, setUseRouteAnimatePresence] = useState(() => {
    // Load from localStorage or default to true
    const saved = localStorage.getItem('useRouteAnimatePresence');
    return saved ? saved === 'true' : true;
  });

  useEffect(() => {
    // Save to localStorage when it changes
    localStorage.setItem('animationMode', useTransformersAnimation ? 'transformers' : 'simple');
  }, [useTransformersAnimation]);

  useEffect(() => {
    // Save to localStorage when it changes
    localStorage.setItem('useAnimatePresence', useAnimatePresence.toString());
  }, [useAnimatePresence]);

  useEffect(() => {
    // Save to localStorage when it changes
    localStorage.setItem('useRouteAnimatePresence', useRouteAnimatePresence.toString());
  }, [useRouteAnimatePresence]);

  const toggleAnimationMode = () => {
    setUseTransformersAnimation(prev => !prev);
  };

  const toggleAnimatePresence = () => {
    setUseAnimatePresence(prev => !prev);
  };

  const toggleRouteAnimatePresence = () => {
    setUseRouteAnimatePresence(prev => !prev);
  };

  return (
    <AnimationContext.Provider value={{ 
      useTransformersAnimation, 
      toggleAnimationMode,
      useAnimatePresence,
      toggleAnimatePresence,
      useRouteAnimatePresence,
      toggleRouteAnimatePresence
    }}>
      {children}
    </AnimationContext.Provider>
  );
};

